'use client';
var COMPONENT_ID = "BaseButton";
var defaultProps = {
    type: "button",
    as: "button",
    contentGap: 8
};

export { COMPONENT_ID, defaultProps };
